import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { ReactComponent as IconDown } from 'svg/chevron-down-solid.svg';
import { ReactComponent as IconCircle } from 'svg/check-circle-regular.svg';

import { NavLink } from 'react-router-dom';
import s from './styles.module.scss';

const ResourceGroupItem = ({
  active,
  className,
  children,
  closeUrl,
  complete,
  subGroup,
  title,
  url,
}) => (
  <>
    <NavLink
      activeClassName={s.active}
      className={cx(s.resourceGroupItem, className)}
      to={`/resources/${active ? closeUrl : url}`}
    >
      <div className={cx(s.title, { [s.subGroup]: subGroup })}>{title}</div>
      {complete && (
        <div className={s.progress}>
          <IconCircle />
        </div>
      )}

      <div className={s.arrow}>
        <IconDown />
      </div>
    </NavLink>
    {active && children}
  </>
);

ResourceGroupItem.defaultProps = {
  active: false,
  className: null,
  closeUrl: '',
  children: null,
  complete: false,
  subGroup: false,
};

ResourceGroupItem.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
  complete: PropTypes.bool,
  children: PropTypes.node,
  subGroup: PropTypes.bool,
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  closeUrl: PropTypes.string,
};

export default ResourceGroupItem;
